import { isEmpty } from 'lodash/fp';

import { Country, PartialFieldNames } from '../../types';
import browserUtils from '../../../../../../../../utils/browser';

type RehydrateFormParams = {
  countries: Country[];
  hasPersistedEventRun?: boolean;
  setTravellerCount: (value: number) => void;
  resetForm: (values: any) => void;
  setSubmitting: (value: boolean) => void;
  setHasFormInitialized: (value: boolean) => void;
  hasFormInitialized: boolean;
  valuesFromUrl?: PartialFieldNames | null;
  formikSessionStorageKey: string;
  travellerCountSessionStorageKey: string;
};

const rehydrateForm = ({
  countries,
  formikSessionStorageKey,
  hasFormInitialized,
  hasPersistedEventRun,
  resetForm,
  setHasFormInitialized,
  setSubmitting,
  setTravellerCount,
  travellerCountSessionStorageKey,
  valuesFromUrl,
}: RehydrateFormParams) => {
  if (hasPersistedEventRun) {
    setHasFormInitialized(false);
    setSubmitting(false);
    return;
  }

  if (hasFormInitialized || isEmpty(countries)) return;
  const { sessionStorage } = browserUtils.getWindow();
  const storedState = sessionStorage.getItem(formikSessionStorageKey);
  const amountOfTravellers = sessionStorage.getItem(travellerCountSessionStorageKey);
  const sessionStorageState = storedState ? JSON.parse(storedState) : null;
  if (!sessionStorageState && !amountOfTravellers && !valuesFromUrl) {
    setHasFormInitialized(true);
    return;
  }
  if (!isEmpty(sessionStorageState) || !isEmpty(valuesFromUrl)) {
    resetForm({ values: !isEmpty(sessionStorageState) ? sessionStorageState : valuesFromUrl });
  }
  if (amountOfTravellers) {
    setTravellerCount(Number(amountOfTravellers));
  }
  setSubmitting(false);
  setHasFormInitialized(true);
};

export default rehydrateForm;
